export default __webpack_public_path__ + "static/media/tidy_avatar_3.abb5488a.png";